/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum OauthSmtpServersHosts {
    Azure = 'graph.microsoft.com',
    Google = 'gmail.googleapis.com',
}
